import React from "react";
import { share } from "../../utils/Helper";
import data from "../../common/ShareText.json";

const Emp_Card = ({ episode, handleShareData, sharetext }) => {
  return (
    <>
      <div className="eae_list_item">
        <label>{episode.sequence}</label>
        <div className="eae_list_item_video">
          <img src={episode.image_url} className="vthumb_1" alt="" />

          <div
            className="eae_list_item_video_overlay"
            style={{ cursor: "pointer" }}
            onClick={() =>
              (window.location.href = `/parikshapecharcha2025/allepisode/${episode.id}`)
            }
          ></div>
          <button
            className="eae_list_item_video_btn"
            onClick={() =>
              (window.location.href = `/parikshapecharcha2025/allepisode/${episode.id}`)
            }
          >
            <img src="/assets/images/playvideoppc.svg" alt="" />
          </button>
        </div>
        <div
          className="eae_list_item_vinfo"
          // onClick={() =>
          //   (window.location.href = `/parikshapecharcha2025/allepisode/${episode.id}`)
          // }
        >
          <h3
            onClick={() =>
              (window.location.href = `/parikshapecharcha2025/allepisode/${episode.id}`)
            }
          >
            {episode.title}
          </h3>

          <p
            className="vdisciptiion"
            onClick={() =>
              (window.location.href = `/parikshapecharcha2025/allepisode/${episode.id}`)
            }
          >
            {episode.description}
          </p>

          <div className="eae_list_item_vControlls">
            <div className="emp_flex">
              <a
                style={{ cursor: "pointer" }}
                className="btn_style_v2"
                onClick={() =>
                  (window.location.href = `/parikshapecharcha2025/allepisode/${episode.id}`)
                }
              >
                <img src="/assets/images/playchange.svg" alt="" /> Watch Now
              </a>

              <a
                style={{ cursor: "pointer" }}
                className="btn_style_v2"
                onClick={() => {
                  share(
                    episode.id,
                    data[episode.id],
                    "youtube",
                    `https://www.narendramodi.in/parikshapecharcha2025/allepisode/${episode.id}`
                  );
                  handleShareData(
                    `https://www.narendramodi.in/parikshapecharcha2025/allepisode/${episode.id}`,
                    data[episode.id],
                    data[episode.id],
                    "youtube"
                  );
                }}
              >
                <img src="/assets/images/shareorange.svg" alt="" /> Share
              </a>
            </div>
            <div>
              <p className="vdutaion">{episode.duration}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Emp_Card;
